import React from 'react'
import { Trans, useTranslation } from 'lib/i18n'
import { pushToDataLayer } from 'lib/tracking'

import Link from 'components/Link/Link'
import { Button } from 'components/UI/Button/Button'
import { DesktopH1, H5 } from 'components/UI/Typography/Typography.new'

import styles from './BusinessPageTitle.module.css'

const BusinessPageTitle = (): JSX.Element => {
  const { t } = useTranslation()

  const logPrimaryCta = () =>
    pushToDataLayer({
      event: 'businessPageHeroContactClick',
    })

  return (
    <div className={styles.wrapper} data-cy="businessPageTitle">
      <div className={styles.title}>
        <DesktopH1 element="h1">
          <Trans i18nKey="BusinessPageTitle.title2">
            Custom videos from celebrities your audience
            <span className={styles.highlight}>already loves</span>
          </Trans>
        </DesktopH1>
      </div>

      <div className={styles.subtitle}>
        <H5 element="h2">
          {t(
            'BusinessPageTitle.subtitle2',
            'Bespoke marketing videos to promote your brand',
          )}
        </H5>
      </div>

      <Link href="/page/business-form">
        <a className={styles.ctaButton} data-cy="businessPageHeroPrimaryCta">
          <Button onClick={logPrimaryCta} type="blue">
            {t('BusinessPageTitle.contactUs2', 'Contact our team')}
          </Button>
        </a>
      </Link>
    </div>
  )
}

export default BusinessPageTitle
